export default "__VITE_ASSET__75a47d8c__"